import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import TariffDescription from "@/components/TariffsPage/TariffDescription.vue";
import TariffFaq from "@/components/TariffsPage/TariffFaq.vue";
import TariffHero from "@/components/TariffsPage/TariffHero.vue";
import TariffList from "@/components/TariffsPage/TariffList.vue";
import TariffStart from "@/components/TariffsPage/TariffStart.vue";
import TariffTable from "@/components/TariffsPage/TariffTable.vue";
import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'TariffsPage',
  setup(__props) {

const store = useStore();
const loggedIn = computed(() => store.state.auth.status.loggedIn);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TariffHero),
    _createVNode(TariffDescription),
    _createVNode(TariffList),
    _createVNode(TariffFaq),
    (!loggedIn.value)
      ? (_openBlock(), _createBlock(TariffStart, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})